import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectClientFarmField');

    return {
        CLIENT_NAME_FIELD_PLACEHOLDER: t('clientNameFieldPlaceholder'),
        FARM_NAME_FIELD_PLACEHOLDER: t('farmNameFieldPlaceholder'),
        INCOMPLETE_SELECTION_WARNING: t('incompleteSelectionWarning'),
        LABEL: t('label')
    };
};

export default useTranslation;
